module.exports = __webpack_public_path__ + "img/2x.af1000c.jpg";